import styled from "styled-components";
import { ReactNode } from "react";

interface ModalProps {
  title: string;
  content: ReactNode;
  isOpen: boolean;
  onClose: () => void;
  onConfirm?: () => void;
}

const Modal = ({ title, content, isOpen, onClose, onConfirm }: ModalProps) => {
  const handleBackClick = (e: React.MouseEvent) => {
    e.stopPropagation();
  };

  return (
    <>
      {isOpen && (
        <Back onClick={onClose}>
          <Box onClick={handleBackClick}>
            <Title>{title}</Title>
            <Content>{content}</Content>
            <Buttons>
              {onConfirm ? (
                <>
                  <ButtonCancel onClick={onClose}>취소</ButtonCancel>
                  <Button onClick={onConfirm}>확인</Button>
                </>
              ) : (
                <Button onClick={onClose}>확인</Button>
              )}
            </Buttons>
          </Box>
        </Back>
      )}
    </>
  );
};

export default Modal;

const Back = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(4px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 3000;
  animation: fadeIn 0.2s ease-out;
`;

const Box = styled.div`
  background-color: white;
  width: 420px;
  padding: 24px;
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  animation: slideUp 0.3s ease-out;
`;

const Title = styled.h2`
  color: #1E293B;
  font-size: 20px;
  font-weight: 600;
  margin: 0 0 24px 0;
  text-align: center;
`;

const Content = styled.div`
  margin: 0 0 32px 0;
  text-align: center;
  width: 100%;
`;

const Buttons = styled.div`
  display: flex;
  gap: 12px;
  width: 100%;
  justify-content: center;
`;

const Button = styled.button`
  min-width: 88px;
  padding: 9px 16px;
  background: #DF0000;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;

  &:hover {
    background: #B91C1C;
  }
`;

const ButtonCancel = styled.button`
  min-width: 88px;
  padding: 9px 16px;
  background: #fff;
  color: #64748B;
  border: 1px solid #E2E8F0;
  border-radius: 8px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;

  &:hover {
    background: #F8FAFC;
    color: #0F172A;
  }
`;

const fadeIn = `
  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;

const slideUp = `
  @keyframes slideUp {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

// Add keyframes to document
const style = document.createElement('style');
style.textContent = fadeIn + slideUp;
document.head.appendChild(style);
